<template lang="pug">
  .wrap
    page-title Add a new Client

    .section
      el-row(:gutter='100')
        el-col(:sm='12')
          .section-title Business

          el-form(label-position='top' ref='companyForm' :model='company' :rules='companyRules')
            el-form-item(label='Business name' prop='name')
              el-input(v-model='company.name')

            el-form-item(label='Business address', prop='address')
              el-input(type='textarea' v-model='company.address')

            el-form-item(label="Account status" prop="isActive")
              el-radio-group(v-model='company.isActive')
                el-radio(:label="true") Active
                el-radio(:label="false") Disable

        el-col(:sm='12')
          .section-title Contact

          user-form(:user='newUser' ref='userForm' :showCompanyAdmin='false')

    .section
      page-title Assign seats to MyEthos apps
      p Each app has a number of seats which determines how many users you can add. You can assign the number of seats for your new client here.

      .app-seats
        .app(v-for='appLicense in appLicenses' :key='appLicense.app.id')
          .app-title {{ appLicense.app.name }}
          .app-seat-input
            el-input-number(:min='0' v-model='appLicense.numOfLicenseSeats')

    .section
      page-title Date/Time settings

      el-form(label-position='top')
        el-form-item(label='Default Timezone')
          timezone-input(v-model='company.defaultTimezone')

    .section
      page-title Currency settings

      el-form(label-position='top')
        el-form-item(label='Default Currency')
          currency-code-input(v-model='company.defaultCurrencyCode')

    .section
      page-title Custom theme settings

      el-form(label-position='top')
        el-row(:gutter='10')
          el-col(:sm='8')
            el-form-item(label='Theme colour')
              el-row(:gutter='10')
                el-col(:span='12')
                  el-input(v-model="company.primaryColour")
                el-col(:span='6')
                  el-color-picker(v-model="company.primaryColour")

          el-col(:sm='8')
            el-form-item(label='Secondary colour')
              el-row(:gutter='10')
                el-col(:span='12')
                  el-input(v-model="company.secondaryColour")
                el-col(:span='6')
                  el-color-picker(v-model="company.secondaryColour")

          el-col(:sm='8')
            el-form-item(label='Background colour')
              el-row(:gutter='10')
                el-col(:span='12')
                  el-input(v-model="company.bgColour")
                el-col(:span='6')
                  el-color-picker(v-model="company.bgColour")

    .actions
      el-button(type='primary' size='large' @click='onSubmit') Create Client


</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CrudMixin from "@/shared/mixins/Crud";
import PageTitle from "@/shared/components/layout/PageTitle";
import UserForm from "@/shared/components/UserForm";
import TimezoneInput from "@/shared/components/TimezoneInput";
import CurrencyCodeInput from "@/shared/components/CurrencyCodeInput";

export default {
  components: { PageTitle, UserForm, TimezoneInput, CurrencyCodeInput },
  mixins: [CrudMixin],
  data() {
    return {
      loading: false,
      companyRules: {
        name: [{ required: true, message: "Required field", trigger: "blur" }]
      },
      company: {
        name: "",
        address: "",
        isActive: true,
        primaryColour: "",
        secondaryColour: "",
        defaultTimezone: "Europe/London"
      },
      newUser: {
        firstName: "",
        lastName: "",
        phoneNum: "",
        email: "",
        jobRole: "",
        isCompanyAdmin: false,
        isActive: true,
        generatePassword: true
      },
      appLicenses: []
    };
  },
  computed: {
    ...mapGetters({})
  },
  methods: {
    ...mapActions({
      fetchApps: "apps/fetchApps",
      createCompany: "companies/createCompany"
    }),
    loadData() {
      this.fetchApps().then(data => {
        this.appLicenses = data.map(app => ({ app, numOfLicenseSeats: 0 }));
      });
    },
    saveUser() {
      const data = {
        ...this.company,
        user: this.newUser,
        appLicenses: this.appLicenses.map(appLicense => ({
          app: appLicense.app.id,
          numOfLicenseSeats: appLicense.numOfLicenseSeats
        }))
      };
      this.wrapApiAction(this.createCompany)({ data }).then(respData => {
        this.$router.push({
          name: "superAdmin:companyEdit",
          params: { companyId: respData.id }
        });
      });
    },
    onSubmit() {
      this.$refs.companyForm.validate(companyValid => {
        this.$refs.userForm.validate(userValid => {
          if (!companyValid || !userValid) {
            this.$notify({
              title: "Error",
              message: "Please fix the validation errors",
              type: "error"
            });
            return;
          }
          this.saveUser();
        });
      });
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/scss/mixins.scss";

.section {
  border-bottom: 1px solid #ccc;
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.section-title {
  letter-spacing: 0.05em;
  font-size: 28px;
  font-family: "gilroylight";
  font-weight: normal;
  margin: 0 0 20px 0;
}
</style>
